import React, { useState } from 'react';
import './SuccessStoriesContent.css'; // Import your CSS for styling

function SuccessStoriesContent() {
  const [selectedImage, setSelectedImage] = useState(null);

  const stories = [
    {
      title: "Project Title 1",
      description: "Brief description of the project and how MBPE's products/services contributed to its success.",
      imageUrl: "path_to_image1.jpg"
    },
    {
      title: "Project Title 2",
      description: "Brief description of another project and MBPE's role in its achievement.",
      imageUrl: "path_to_image2.jpg"
    },
    {
      title: "Project Title 3",
      description: "Brief description of project 3 and its success.",
      imageUrl: "path_to_image3.jpg"
    },
    {
      title: "Project Title 4",
      description: "Brief description of project 4 and its success.",
      imageUrl: "path_to_image4.jpg"
    },
    // Add more stories to fill up 4x4 grid
    {
      title: "Project Title 5",
      description: "Brief description of project 5 and its success.",
      imageUrl: "path_to_image5.jpg"
    },
    {
      title: "Project Title 6",
      description: "Brief description of project 6 and its success.",
      imageUrl: "path_to_image6.jpg"
    },
    {
      title: "Project Title 7",
      description: "Brief description of project 7 and its success.",
      imageUrl: "path_to_image7.jpg"
    },
    {
      title: "Project Title 8",
      description: "Brief description of project 8 and its success.",
      imageUrl: "path_to_image8.jpg"
    },
    // Repeat or add up to 16 items
  ];

  const openFullScreen = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeFullScreen = () => {
    setSelectedImage(null);
  };

  return (
    <div>
      <h2>Success Stories</h2>
      <div className="success-stories-grid">
        {stories.map((story, index) => (
          <div key={index} className="success-story">
            <h3>{story.title}</h3>
            <p>{story.description}</p>
            <div className="image-container">
              <img
                src={story.imageUrl}
                alt={story.title}
                onClick={() => openFullScreen(story.imageUrl)}
                className="story-image"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Modal for full-screen image */}
      {selectedImage && (
        <div className="modal" onClick={closeFullScreen}>
          <span className="close-modal">&times;</span>
          <img src={selectedImage} alt="Full screen" className="modal-content" />
        </div>
      )}
    </div>
    
  );
}

export default SuccessStoriesContent;
